import React from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import Header from '../components/Header';
import ItemsContainer from '../components/ItemsContainer';
import useAuth from '../hooks/useAuth';

const VendorItems = () => {

    const { user, data } = useAuth()
    const navigate = useNavigate()

    const handleSubmit = () => {

        document.getElementById('submit-action').style.display = 'none'
        document.getElementById('upload-processing').style.display = 'block'

        const details = {
            code: user.code,
            name: user.name,
            date: new Date().toISOString().split('T')[0],
            products: data
        }

        fetch('https://vendor-managed-inventory-transparency.onrender.com/vendor-inventory-stock', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(details)
        })
            .then(res => res.json())
            .then(result => {
                if (result.status === false) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Something went wrong',
                        text: `result.message`,
                    })
                }
                else {
                    navigate('/file-upload-success')
                }
            })
    }

    return (
        <div className='bg-brand'>

            <div className="container">
                <Header />

                <ItemsContainer data={data} />

                <div className="d-flex justify-content-center align-items-center mt-3">
                    <button id='submit-action' onClick={() => handleSubmit()} className='btn-action w-50'>Submit file</button>
                    <button style={{ display: 'none' }} id='upload-processing' className='btn-action w-50' disabled><div style={{ height: '15px', width: '15px' }} className="spinner-border me-1"></div>Processing . . .</button>
                </div>

            </div>

        </div>
    );
};

export default VendorItems;